import { UserEntry, UserFolders, UserProfile } from '@/types/api'
import createStore from './factory'

type SessionStoreData = {
  user?: UserEntry
  folders?: UserFolders
  profiles?: UserProfile[]
}

export default class Session extends createStore(
  {
    setUser(state, user: UserEntry | undefined) {
      const sameId = state.user?.id === user?.id
      state = { ...state, user }
      if (!sameId) {
        state.folders = undefined
        state.profiles = undefined
      }
      return state
    },

    setFolders(
      state,
      folders: UserFolders | ((prev: UserFolders) => UserFolders)
    ) {
      const prev = state.folders
      if (typeof folders === 'function') {
        if (!prev) return state
        folders = folders(prev)
      }
      if (folders === prev) return state
      return { ...state, folders }
    },

    setProfiles(
      state,
      profiles: UserProfile[] | ((prev: UserProfile[]) => UserProfile[])
    ) {
      const prev = state.profiles
      if (typeof profiles === 'function') {
        if (!prev) return state
        profiles = profiles(prev)
      }
      if (profiles === prev) return state
      return { ...state, profiles }
    }
  },
  {} as SessionStoreData
) {
  // nothing to see here
}
